import React from 'react'
import styled from '@emotion/styled'

const SubPageTopBG = ({ children }) => {
  return <BackGround>{children}</BackGround>
}

const BackGround = styled.div`
  position: relative;
  background-color: #eff7fc;
`

export default SubPageTopBG
